export default {"src":"/_next/static/media/empty.2995f5a0.svg","height":349,"width":463};